import { ComponentPropsWithoutRef } from 'react';

export default function PrimeTag(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="17px"
      height="17px"
      viewBox="0 0 17 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>7919EA9D-6317-44EF-B930-AB3A11BC7E99</title>
      <defs>
        <linearGradient
          x1="9.95673432%"
          y1="3.10803324%"
          x2="128.24389%"
          y2="14.243744%"
          id="linearGradient-1"
        >
          <stop stopColor="#67A4FF" offset="0%" />
          <stop stopColor="#0E00FF" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id="taker-profile-data"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="tfr-/-2" transform="translate(-538, -227)">
          <g id="hover-info" transform="translate(534.7857, 223.5)">
            <g id="prime-tag" transform="translate(4, 4)">
              <rect
                id="Rectangle"
                fill="#000000"
                x="0"
                y="0"
                width="16"
                height="16"
                rx="2.0999999"
              />
              <g
                id="Group-14"
                transform="translate(1.8995, 2.0921)"
                fill="url(#linearGradient-1)"
                fillRule="nonzero"
              >
                <path
                  d="M6.1131249,0 L6.113,0.255 L6.116816,0.284673868 C6.5318697,3.93974576 8.47015136,5.8129701 11.931661,5.90434689 L12.2009354,5.90786139 C8.4797923,5.90786139 6.44211157,7.87714852 6.08789318,11.8157228 L6.113,11.56 L6.1131249,11.8157228 L6.1,11.688 L6.08789318,11.8157228 L6.087,11.56 L6.08420209,11.5310489 C5.65850598,7.78225723 3.63046619,5.90786139 8.27126599e-05,5.90786139 L0.269357079,5.90434689 C3.81962337,5.8106271 5.76754598,3.84251147 6.1131249,0 L6.087,0.255 L6.08789318,0 L6.1,0.127 L6.1131249,0 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
